import type { RunGateResponse } from "@patent-studio/api-types";
import type { NoveltyTabId } from "../stage-vocabulary";

/**
 * Which of the novelty page's tabs the attorney may walk onto. `built` says a
 * route answers; this says whether walking there would land on anything, and
 * the strip needs both. One projection, so the strip cannot offer an address
 * the guard behind it redirects away from. An unread gate holds everything
 * open, as both guards do with one.
 */
export function reachableTabs(
  gate: RunGateResponse | undefined,
): Readonly<Record<NoveltyTabId, boolean>> {
  if (gate === undefined) {
    return { positions: true, "prior-art": true, analysis: true };
  }
  return {
    positions: true,
    "prior-art": true,
    analysis: gate.analysis.status !== "not_started",
  };
}
